export default {"src":"/_next/static/media/rating-3.5.c40c284f.svg","height":96,"width":512,"blurWidth":0,"blurHeight":0};